<template>
    <div 　align="center" >

                <el-row :gutter="10" type="flex" justify="center">
                    <el-col :xs="24" :sm="20" :md="16" :lg="8" :xl="8"><div class="grid-content bg-purple">
                        <div style="width:100%;height: 100%;overflow: hidden">


                            <div style="width:100%; alignment: center">
                                <div style="font-size:30px;color:dodgerblue;margin-bottom: 20px;text-align: center"><img
                                        src="../pic/bg.png" height="240" width="360"/></div>
                                <div> <el-form ref="form" :model="form"  style="margin-bottom: 20px" >
                                    <el-form-item>
                                        <el-input v-model="form.code" style="width:100%;"></el-input>
                                    </el-form-item>
                                    <el-button style="width: 100%;" type="success" @click="search">查询</el-button>
                                </el-form></div>
                                <custom-input v-model="searchText"></custom-input>

                                <div> <el-timeline :reverse="reverse">
                                    <el-timeline-item
                                            v-for="(activity, index) in logisticsList"
                                            :key="index"
                                            :timestamp="activity.ddates.slice(0,19)">
                                        {{activity.information}}
                                    </el-timeline-item>
                                </el-timeline></div>


                                <!-- <div><baidu-map :center="center" :zoom="zoom" @ready="handler" style="width:100%;height:380px;" @click="getClickInfo" :scroll-wheel-zoom='true'>-->
                                <!--   <bm-polyline :path=polylinePath stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="3" :editing="false"></bm-polyline>-->
                                <!-- </baidu-map></div>-->



                            </div>



                        </div>
                    </div></el-col></el-row>




</div>

</template>
<!--<script type="text/javascript" src="http://api.map.baidu.com/api?v=2.0&ak=5a5mYi83sMCOP3NXv2iw8sKLYu511eo8"></script>-->

<script>
import request from "@/untils/request";

export default {
  name: 'HelloWorld',
  data() {

   return {
     fileData: {
       fileId: '',
       fileType: '',
       fileDesc: '',
       filePath: '',
     },



   form: {
      code: ''
           },
     logisticsList:[],
     logisticsLista: [
       {
         message: '1包裹已签收，感谢您使用顺丰快递服务，期待下次继续为您服务！',
         messageDate: '2016-03-10 18:07:15'
       },
       {
         message: '2包裹已签收，感谢您使用顺丰快递服务，期待下次继续为您服务！',
         messageDate: '2016-03-10 18:07:15'
       },
       {
         message: '3包裹已签收，感谢您使用顺丰快递服务，期待下次继续为您服务！',
         messageDate: '2016-03-10 18:07:15'
       },
       {
         message: '4包裹已签收，感谢您使用顺丰快递服务，期待下次继续为您服务！',
         messageDate: '2016-03-10 18:07:15'
       },
       {
         message: '5包裹已签收，感谢您使用顺丰快递服务，期待下次继续为您服务！',
         messageDate: '2016-03-10 18:07:15'
       },
       {
         message: '6包裹已签收，感谢您使用顺丰快递服务，期待下次继续为您服务！',
         messageDate: '2016-03-10 18:07:15'
       }
     ],
     polylinePath:[],
     message:'',
     file: {},
     fileList: []

   }


  },
  methods: {


    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    // handler({BMap, map}) {
    //   var point = new BMap.Point(116.382342,39.871286);
    //   map.centerAndZoom(point, 2);
    //   map.enableScrollWheelZoom(true);},
    search(){
      // request.get("/api/ai-status/GETA").then(res=>{console.log(res) ,this.form.code=res.msg});
      request.get("demo/api/demo/logistics/GET",{
        params:{
          code:this.form.code
        }
      }).then(res=>{console.log(res.data),this.logisticsList=res.data.list});
      console.log(this.logisticsList);
      // console.log(this.polylinePath)   ,this.polylinePath=res.data.polylinePath;
    },
   // newmap(){
   //   var polyline = new BMap.Polyline([
   //     new BMap.Point(116.382342,39.871286),
   //     new BMap.Point(139.729468,38.368869),
   //     new BMap.Point(-114.09332,42.369224),
   //     new BMap.Point(-68.909559,-48.843573),
   //   ], {strokeColor:"blue", strokeWeight:6, strokeOpacity:0.5});
   //   this.map.addOverlay(polyline);
   //   // setTimeout(function(){
   //   var view = map.getViewport(eval(polyline));
   //   var mapZoom = view.zoom;
   //   var centerPoint = view.center;
   //   this.map.centerAndZoom(centerPoint,mapZoom);
   //   //setZoom(polyline);
   //   // }, 3000);
   //   // 根据点的数组自动调整缩放级别
   //
   //
   //
   //
   // },
   //  addlujing(){
   //    this.polylinePath=[{lng:116.382342,lat:39.871286},
   //      {lng:139.729468,lat:38.368869},
   //      {lng:-114.09332,lat:42.369224},
   //      {lng:-68.909559,lat:-48.843573}]
   //
   //  }

    submit(){

      alert(this.message);


    }


    /*getClickInfo(e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    }*/
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    center{
        　　text-align:center;
    }



    bg-purple {
        background: #d3dce6;
    }
html {
  background-color: #f2f2f2;
}
ul,li{
  list-style: none;
}
.order_track {
  background-color: #fff;
  margin-bottom: 0.5em;
  padding: 0.5em;
}
.order_track p {
  font-size: 1.0em;
  line-height: 1.5;
  color: #666;
  margin-bottom: 0;
}
.order_track p span {
  color: #333;
}
.order_logistics{
  padding-left: 2.0em;
  background-color: #fff;
}
.order-flow {
  padding-left: 0em;
  padding-bottom: 1.0em;
  position: relative;
}
.order-flow:before{
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  border-left: 1px solid rgb(230, 230, 230);/* 直接改变border的位置即可 */
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scale(0.5, 0.5);
  transform: scale(0.5, 0.5);
  box-sizing: border-box;
}
.of-storey li {
  position: relative;
  padding: 10px;
  /* border-bottom: 1px solid #e8e5e5; */
}
.of-storey li:after{
  content: " ";
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  bottom: 0;
  border-bottom: 1px solid rgb(230, 230, 230);
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(.5);
  transform: scaleY(.5);
}
.of-storey li span {
  display: block;
  font-size: 1.0em;
  color: #666;
}
.of-storey li span.time {
  font-size: 0.9em;
  color: #999;
}
.of-storey li .icon {
  position: absolute;
  top: 45%;
  left: -2.75em;
  width: 9px;
  height: 9px;
  border-radius: 5px;
  background-color: #ccc;
}
.of-storey li .icon.on {
  background-color: #0099ff;
}
#allmap {width: 100%;height: 100%;overflow: hidden;margin:0;font-family:"微软雅黑";}


</style>
